import React, { useState } from "react";
import { ArrowUpRight, TrendingUp, Users, MousePointerClick, ChartBar, Globe, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const CAMPAIGNS = [];
const FILTERS = ["All", "Concrete", "Masonry"];
export default function ProvenImpacts() {
  const [activeFilter, setActiveFilter] = useState("All");
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const filteredCampaigns = activeFilter === "All" ? CAMPAIGNS : CAMPAIGNS.filter(c => c.category === activeFilter);
  return;
}